import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { Params, RouterLink } from '@angular/router';
import { TableColumn } from '@ui/aos-lib';

export enum CustomizableColumnType {
  TEXT = 'TEXT',
  LINK = 'LINK',
  LINK_WITH_QUERY_PARAMS = 'LINK_WITH_QUERY_PARAMS'
}

export type CustomizableTableColumnValue = {
  text: string;
  routerLink?: string[];
  queryParams?: Params;
};

export type CustomizableTableColumn = TableColumn & {
  options: {
    columnType: CustomizableColumnType;
    columnValues: (
      tableItem: { [key: string]: string | string[] | null },
      tableColumn: TableColumn
    ) => CustomizableTableColumnValue[];
  };
};

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink],
  template: `
    <div class="wrapper">
      @for (value of values(); track $index) {
        <div class="wrapper__row">
          @if ($any(column()).options?.columnType === multilineColumnType.LINK_WITH_QUERY_PARAMS) {
            <a
              class="ui-link-button ui-link-button_dashed"
              [routerLink]="value.routerLink"
              [queryParams]="value.queryParams"
            >
              {{ value.text }}
            </a>
          } @else if ($any(column()).options?.columnType === multilineColumnType.LINK) {
            <a
              class="ui-link-button ui-link-button_dashed"
              [routerLink]="value.routerLink"
            >
              {{ value.text }}
            </a>
          } @else {
            {{ value.text }}
          }
        </div>
      }
    </div>
  `,
  styles: `
    .wrapper__row + .wrapper__row {
      margin-top: 0.5rem;
    }
  `
})
export class CustomizableColumnComponent {
  item = input.required<{ [key: string]: string | string[] | null }>();
  column = input.required<TableColumn>();

  protected readonly multilineColumnType = CustomizableColumnType;

  protected values = computed(() => {
    return (this.column() as CustomizableTableColumn)?.options?.columnValues?.(this.item(), this.column());
  });
}
